module.exports = __webpack_public_path__ + "static/media/offroad.1a0ae88f.svg";